import { sum } from 'lodash';
import type { Cell, ITableLayer } from '@/version-types';
import { applyTableLayout, getTableCellRequiredHeight } from './table-layout';

/**
 * 内容编辑只允许布局向外增长，避免覆盖用户手动设置的行列尺寸。
 * 文本的断行、高度与最小字形宽度统一由 pretext 计算。
 */
export const resolveTableCellTextLayout = (layer: ITableLayer, editedCellId: string): ITableLayer => {
    const editedCell = layer.data.cells.flat().find((cell) => cell?.__renderId === editedCellId);
    if (!editedCell) return layer;
    return applyTableLayout(layer, { mode: 'repair' });
};

/**
 * 编辑草稿只允许目标单元格覆盖的行向外增长。
 * 草稿内容只用于测量，不会写入图层数据，也不会改变列宽。
 */
export const resolveTableCellDraftVerticalLayout = (
    layer: ITableLayer,
    editedCellId: string,
    draft: string,
): ITableLayer => {
    const editedCell = layer.data.cells.flat().find((cell) => cell?.__renderId === editedCellId);
    if (!editedCell) return layer;

    const measurementCell: Cell = { ...editedCell, content: draft };
    const requiredHeight = getTableCellRequiredHeight(layer, measurementCell, layer.data.baseCells.horizontal);
    const { vertical } = layer.data.baseCells;
    const currentHeight = sum(vertical.slice(editedCell.vIndex, editedCell.vIndex + editedCell.rowSpan));
    const delta = requiredHeight - currentHeight;
    if (delta <= 0) return layer;

    vertical[editedCell.vIndex + editedCell.rowSpan - 1] += delta;
    layer.height += delta;
    return layer;
};
